import { type FormEvent, useState } from "react";
import { isComplete, type MissingFields, missingFields } from "./loginForm";

export interface LoginSubmission {
  email: string;
  password: string;
  rememberMe: boolean;
}

/**
 * State of the login form. `attempt` grows on every submission that reaches `onSubmit`, so the
 * error alert remounts (and shakes) again for a repeated failure.
 */
export function useLoginForm(initialEmail: string, offerRememberMe: boolean, onSubmit: (values: LoginSubmission) => void) {
  const [email, setEmail] = useState(initialEmail);
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [attempt, setAttempt] = useState(0);
  const [missing, setMissing] = useState<MissingFields>({});

  function handleSubmit(e: FormEvent): void {
    e.preventDefault();
    const next = missingFields({ email, password });
    setMissing(next);
    if (!isComplete(next)) return;
    setAttempt((n) => n + 1);
    onSubmit({ email: email.trim(), password, rememberMe: offerRememberMe && rememberMe });
  }

  return { email, setEmail, password, setPassword, rememberMe, setRememberMe, attempt, missing, handleSubmit };
}
